module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dedicated-solutions"
  }, [_c('v-dedicated-filter', {
    ref: "filter",
    attrs: {
      "components": _vm.COMPONENTS,
      "items": _vm.ITEMS
    },
    model: {
      value: (_vm.filteredIds),
      callback: function($$v) {
        _vm.filteredIds = $$v
      },
      expression: "filteredIds"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dedicated-solutions-list"
  }, [_vm._m(0), _vm._v(" "), (Object.keys(_vm.filterItems).length) ? _c('div', {
    staticClass: "dedicated-solutions-filtered"
  }, [_vm._l((_vm.filterItems), function(item) {
    return [(item.CODE == 'CLEAR_ALL') ? [_c('div', {
      staticClass: "filtered-item removed-all",
      on: {
        "click": function($event) {
          return _vm.run(item.delete)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.NAME))]), _vm._v(" "), _c('img', {
      attrs: {
        "src": "/local/templates/depohost/pictures/icons/trash.svg",
        "alt": "delete"
      }
    })])] : [_c('div', {
      staticClass: "filtered-item",
      on: {
        "click": function($event) {
          return _vm.run(item.delete)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.NAME))]), _vm._v(" "), _c('img', {
      attrs: {
        "src": "/local/templates/depohost/pictures/icons/times.svg",
        "alt": "delete"
      }
    })])]]
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dedicated-solutions-item-wrapper"
  }, _vm._l((_vm.filteredItems), function(item) {
    return _c('v-dedicated-item', {
      key: item.ID,
      attrs: {
        "item": item,
        "components": _vm.COMPONENTS
      }
    })
  }), 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dedicated-solutions-filter-open"
  }, [_c('span', {
    staticClass: "btn ripple"
  }, [_c('span', [_vm._v("Фильтры")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/local/templates/depohost/pictures/icons/filter.svg",
      "alt": "filter"
    }
  })])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-76b2db82", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-76b2db82!./~/vue-loader/lib/selector.js?type=template&index=0!./depohost.ru/local/templates/depohost/components/bitrix/catalog.section/dedicated-solutions/template.vue
// module id = 25
// module chunks = 0